import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { IWarkDistanceAndTime } from "@ryde/shared";

import { MapLibreWalkingRouteTooltipStyled } from "./maplibre-walking-route.styled";

/**
 * Walk distance + time card shown against a walking route. Keeps the Leaflet markup's inner class names,
 * but brings its own styling rather than depending on the consuming screen to declare it.
 */
export const MapLibreWalkingRouteTooltip: FC<{
  distanceAndTime: IWarkDistanceAndTime;
}> = ({ distanceAndTime }) => {
  const { t } = useTranslation();
  const { distance, duration } = distanceAndTime;

  return (
    <MapLibreWalkingRouteTooltipStyled>
      <div>
        <PIC.WalkMenSvg />
      </div>
      <div className="map-location-tooltip-content">
        <div className="map-location-tooltip-distance">
          <b>{distance}</b> {t("general.Meters")}
        </div>
        <div className="map-location-tooltip-duration">
          <div className="map-location-tooltip-bold">
            {duration.minutes}:{duration.seconds}
          </div>
          <div>{t("general.Minutes")}</div>
        </div>
      </div>
    </MapLibreWalkingRouteTooltipStyled>
  );
};
